import React, { createContext, useContext } from 'react';
import { useJsApiLoader } from '@react-google-maps/api';
import config from '../config';

// Create context for Google Maps
const GoogleMapsContext = createContext();

// Define all libraries we need across the app
const libraries = ['places', 'marker'];

// Provider component
export const GoogleMapsProvider = ({ children }) => {
  const { isLoaded, loadError } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: config.googleMapsApiKey,
    libraries,
    mapIds: ['austnews-crm-map'] // Add map ID for Advanced Markers
  });

  const value = {
    isLoaded,
    loadError,
    libraries
  };

  return (
    <GoogleMapsContext.Provider value={value}>
      {children}
    </GoogleMapsContext.Provider>
  );
};

// Hook to use Google Maps context
export const useGoogleMaps = () => {
  const context = useContext(GoogleMapsContext);
  if (!context) {
    throw new Error('useGoogleMaps must be used within a GoogleMapsProvider');
  }
  return context;
};

export default GoogleMapsProvider;
